const hiddenItems = document.querySelectorAll('.js-custom-product-variant.is-hidden');
const button = document.querySelector('.js-custom-product-variant-button');

if (hiddenItems && button) {
	button.addEventListener('click', () => {
		hiddenItems.forEach((item) => {
			item.classList.remove('is-hidden');
		})

		button.setAttribute('disabled', true);
	})
}

// styl nog

const variantItems = document.querySelectorAll('input[name="Styl nóg"]');
const valueText = document.querySelector('#form__legs-value');

if (variantItems && valueText)
	{
		variantItems.forEach((item) => {
			item.addEventListener('click', () => {
				valueText.textContent = item.value;
			})
		})
	}

// hover label handling
const variantSections = document.querySelectorAll('.custom-product-variants__hld');

variantSections.forEach((section) => {
	const hoverLabel = section.querySelector('.js-product-variant-hover-label');
	const colorVariantItems = section.querySelectorAll('.js-custom-product-variant');

	if (!hoverLabel || colorVariantItems.length === 0) {
		return;
	}

	const showHoverLabel = (labelText, item) => {
		if (!labelText) {
			hoverLabel.textContent = '';
			hoverLabel.hidden = true;
			hoverLabel.classList.remove('is-visible');
			return;
		}

		hoverLabel.textContent = labelText;
		hoverLabel.hidden = false;
		hoverLabel.classList.add('is-visible');

		const sectionRect = section.getBoundingClientRect();
		const itemRect = item.getBoundingClientRect();
		const top = itemRect.bottom - sectionRect.top + 4;
		let left = itemRect.left - sectionRect.left + itemRect.width / 2;

		hoverLabel.style.top = `${top}px`;
		hoverLabel.style.left = `${left}px`;

		requestAnimationFrame(() => {
			const tooltipWidth = hoverLabel.offsetWidth;
			const maxLeft = section.clientWidth - tooltipWidth / 2 - 4;
			let leftMostItem = null;
			let leftMostPosition = Number.POSITIVE_INFINITY;

			colorVariantItems.forEach((variantItem) => {
				const variantItemRect = variantItem.getBoundingClientRect();
				if (variantItemRect.left < leftMostPosition) {
					leftMostPosition = variantItemRect.left;
					leftMostItem = variantItem;
				}
			});

			const isFirstItem = leftMostItem === item;

			if (isFirstItem) {
				left = Math.min(left, maxLeft);
			} else {
				const minLeft = tooltipWidth / 2 + 4;
				left = Math.max(minLeft, Math.min(left, maxLeft));
			}
			hoverLabel.style.left = `${left}px`;
		});
	};

	const hideHoverLabel = () => {
		hoverLabel.textContent = '';
		hoverLabel.hidden = true;
		hoverLabel.classList.remove('is-visible');
	};

	colorVariantItems.forEach((item) => {
		const labelText = item.dataset.longFabricsName || '';

		item.addEventListener('mouseenter', () => {
			showHoverLabel(labelText, item);
		});

		item.addEventListener('mouseleave', hideHoverLabel);
		item.addEventListener('focusin', () => {
			showHoverLabel(labelText, item);
		});
		item.addEventListener('focusout', hideHoverLabel);
	});

	section.addEventListener('mouseleave', hideHoverLabel);
});
